import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { DisplayModes } from '../../../models/enums';
import { ItemBrandService } from '../../item-brand/item-brand.service';
import { LookupsService } from '../../../services/lookups.service';
import { ItemsApiService } from '../../services/items-api.service';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { SalesFileService } from '../../services/sales-file.service';
import { PlanStatus } from '../../../plan/enums/plan-status.enum';
import { forkJoin } from 'rxjs';
import { HcoService } from '../../../settings/components/hco/hco.service';
import { AuthService } from '../../../services/auth.service';


@Component({
  selector: 'crm-add-user-target-request',
  templateUrl: './add-user-target-request.component.html',
  styleUrls: ['./add-user-target-request.component.css']
})
export class AddUserTargetRequestComponent implements OnInit {

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() viewMode: boolean;
  @Input() reviewMode: boolean;
  @Input() selectedRequestId: number;
  @Input() requestType: number;

  itemBrands: any[];
  months: any[] = [{ id: 1, name: 'January' }, { id: 2, name: 'February' }, { id: 3, name: 'March' }, { id: 4, name: 'April' }, { id: 5, name: 'May' }, { id: 6, name: 'June' }, { id: 7, name: 'July' },
  { id: 8, name: 'August' }, { id: 9, name: 'September' }, { id: 10, name: 'October' }, { id: 11, name: 'November' }, { id: 12, name: 'December' }];
  years: any[] = [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030].map(y => ({ label: y, value: y }));
  percentageBasedOn: any[] = [{ id: 1, name: 'Target' }, { id: 2, name: 'Sales' }];

  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  displayMode: any;
  selectedBrands: any[];
  selectedMonths: any[];
  selectedYear: any;
  targetRequest = {} as any;
  pageSize = 1000;
  applyFilters = false;
  organizationTypes: any[];
  items: any[];
  hcos: any[];
  currentUser;
  parentRequest;

  constructor(private translateService: AppTranslationService, private alertService: AlertService, private authService: AuthService,
    private accountService: AccountService, private salesFileService: SalesFileService, private readonly hcoService: HcoService,
    private itemBrandService: ItemBrandService, private readonly lookupsService: LookupsService, private readonly itemsApiService: ItemsApiService,) { }

  ngOnInit() {
    this.currentUser = this.authService.currentUser;

    forkJoin(this.itemBrandService.search(''),
      this.lookupsService.getAllOrganizationTypes(""),
      this.itemsApiService.getAllItems(),
      this.hcoService.getAll()).subscribe(async ([response1, response2, response3, response4]) => {
        this.itemBrands = response1 as any[];
        this.organizationTypes = response2 as any[];

        this.items = response3 as any[];
        this.hcos = response4 as any[];
        this.displayMode = DisplayModes.Success;
        if (this.selectedRequestId)
          await this.getRequestById(this.selectedRequestId);
        else {
          this.targetRequest.type = this.requestType;
          this.targetRequest.userTargetRequestDetail = [];
        }
      })
  }

  async getRequestById(requestId) {
    this.salesFileService.getUserTargetRequestById(requestId).subscribe(async responce => {
      this.targetRequest = responce as any;
      let monthes = [] as any;
      let brandsIds = [] as any;
      let itemsIds = [] as any;
      let orgeTypesIds = [] as any;
      let hcoIds = [] as any;

      if (!this.targetRequest.userTargetRequestDetail || this.targetRequest.userTargetRequestDetail.length == 0) {  // in case of complete reeuqest
        let res = await this.salesFileService.getUserTargetRequestById(this.targetRequest.parentRequestId).toPromise();
        this.parentRequest = res as any;
        monthes = this.parentRequest.userTargetRequestDetail.map(x => x.month);
        this.selectedYear = this.parentRequest.userTargetRequestDetail[0].year;



        if (this.targetRequest.type == 2 || this.targetRequest.type == 3) {
          if (this.currentUser.businessUnitsTree && this.currentUser.businessUnitsTree.length > 0) {

            for (let i = 0; i < this.currentUser.businessUnitsTree.length; i++) {
              if (!this.targetRequest.selectedOrgTypes || this.targetRequest.selectedOrgTypes.length == 0) {
                let userOrgTypesRes = await this.lookupsService.getBusinessUnitOrganizationTypeAsync(this.currentUser.businessUnitsTree[i]).toPromise();
                let userOrgTypes = userOrgTypesRes as any[];
                this.targetRequest.selectedOrgTypes = userOrgTypes.filter(x => (this.targetRequest.type == 2 && x.parentId == null) || (this.targetRequest.type == 3 && x.parentId != null));
                debugger;
              }
            }


          }
          if (this.targetRequest.type == 2) {
            brandsIds = this.parentRequest.userTargetRequestDetail.map(x => x.itemBrandId);
            this.targetRequest.selectedItems = this.items.filter(x => brandsIds.indexOf(x.itemBrandId) > -1);
            //this.targetRequest.selectedOrgTypes = this.organizationTypes;
          }
          if (this.targetRequest.type == 3) {
            brandsIds = this.parentRequest.userTargetRequestDetail.map(x => x.itemBrandId);
            this.targetRequest.selectedItems = this.items.filter(x => brandsIds.indexOf(x.itemBrandId) > -1);
            //this.targetRequest.selectedOrgTypes = this.organizationTypes;
          }
         
        }
        if (this.targetRequest.type == 4) {
          orgeTypesIds = this.parentRequest.userTargetRequestDetail.map(x => x.organizationTypeId);
          this.targetRequest.selectedHcos = this.hcos.filter(x => orgeTypesIds.indexOf(x.organizationTypeId) > -1);
        }
      }
      else {
        this.selectedYear = this.targetRequest.userTargetRequestDetail[0].year;
        monthes = this.targetRequest.userTargetRequestDetail.map(x => x.month);
        brandsIds = this.targetRequest.userTargetRequestDetail.map(x => x.itemBrandId);
        itemsIds = this.targetRequest.userTargetRequestDetail.map(x => x.itemId);
        this.targetRequest.selectedItems = this.items.filter(x => itemsIds.indexOf(x.id) > -1);
        orgeTypesIds = this.targetRequest.userTargetRequestDetail.map(x => x.organizationTypeId);
        this.targetRequest.selectedOrgTypes = this.organizationTypes.filter(x => orgeTypesIds.indexOf(x.id) > -1);
        hcoIds = this.targetRequest.userTargetRequestDetail.map(x => x.hcoId);
        this.targetRequest.selectedHcos = this.hcos.filter(x => hcoIds.indexOf(x.id) > -1);
      }


      if (this.itemBrands) {
        this.selectedBrands = this.itemBrands.filter(x => brandsIds.indexOf(x.id) > -1);
        this.targetRequest.selectedBrands = this.itemBrands.filter(x => brandsIds.indexOf(x.id) > -1);
      }
      if (this.months) {
        this.selectedMonths = this.months.filter(x => monthes.indexOf(x.id) > -1);
        this.targetRequest.selectedMonths = this.months.filter(x => monthes.indexOf(x.id) > -1);
      }

      if (this.targetRequest.percentageBasedOn) {
        this.targetRequest.percentageBasedOnModel = this.percentageBasedOn.find(x => x.id == this.targetRequest.percentageBasedOn)
      }
      this.pageSize = this.targetRequest.userTargetRequestDetail.length + 1;

      debugger;
      this.apply();
    },
      err => {

        console.log('error in get item brands');
        console.log(err);
      })
  }



  back() {
    this.closeEvent.emit(true);
  }

  approve() {
    this.targetRequest.status = PlanStatus.approved;
    this.saveRequest();
  }

  reject() {
    this.targetRequest.status = PlanStatus.rejected;
    this.saveRequest();
  }

  submit() {
    this.targetRequest.status = PlanStatus.pending;

    if (this.targetRequest.type == 1) {
      this.targetRequest.status = PlanStatus.approved;
    }
    this.saveRequest();
  }

  save() {
    this.targetRequest.status = PlanStatus.new;
    this.saveRequest();
  }


  saveRequest() {
    console.log(this.targetRequest)
    if (!this.targetRequest.userTargetRequestDetail || this.targetRequest.userTargetRequestDetail.length == 0) {
      return;
    }
    if (this.targetRequest.percentageBasedOnModel)
      this.targetRequest.percentageBasedOn = this.targetRequest.percentageBasedOnModel.id
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
    this.salesFileService.saveUserTargetRequest(this.targetRequest).subscribe(responce => {
      this.alertService.stopLoadingMessage();
      if (responce)
        this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
      else
        this.alertService.showMessage("", this.translateService.getTranslation("Error"), MessageSeverity.Error);
      this.back();
    },
      err => {
        this.alertService.stopLoadingMessage();
        this.alertService.showMessage("", this.translateService.getTranslation("Error"), MessageSeverity.Error);
        console.log('error in get getAllOrganizationTypes');
        console.log(err);
      })


  }

  onSelectAllMonths() {
  }
  onSelectAllBrands(brands) {
    this.selectedBrands = brands;
    this.onItmBrandsChanged();
  }

  onItmBrandsChanged() {
  }

  onMonthChanged() { }

  apply() {
    if (this.selectedMonths) {
      let monthCount = this.selectedMonths.length;
      this.selectedMonths = this.selectedMonths.sort((a, b) => a.id - b.id);
      let firstMonth = this.selectedMonths[0].id;
      let lastMonth = this.selectedMonths[monthCount - 1].id;
      if ((lastMonth - firstMonth) != monthCount - 1) {

        this.alertService.showStickyMessage("", this.translateService.getTranslation("Invalid selection: Months must be consecutive"),
          MessageSeverity.Warn);
        return;
      }
    }


    debugger;
    this.targetRequest.selectedBrands = this.selectedBrands
    this.targetRequest.selectedMonths = this.selectedMonths

    let monthIds = this.selectedMonths.map(x => x.id)


    if (!this.targetRequest.userTargetRequestDetail)
      this.targetRequest.userTargetRequestDetail = [];


    if (this.targetRequest.type == 1 && this.selectedBrands) {
      let brandsIds = this.selectedBrands.map(x => x.id)
      this.targetRequest.userTargetRequestDetail = this.targetRequest.userTargetRequestDetail.filter(x => brandsIds.indexOf(x.itemBrandId) > -1 && monthIds.indexOf(x.month) > -1 && x.year == this.selectedYear);

      this.selectedBrands.forEach(brand => {
        this.selectedMonths.forEach(month => {
          let entry = this.targetRequest.userTargetRequestDetail.find(
            x => x.itemBrandId === brand.id && x.month === month.id
          );
          if (!entry) {
            this.targetRequest.userTargetRequestDetail.push({
              itemBrandId: brand.id, month: month.id, target: 0, year: this.selectedYear
            })
          }
        });
      })
    }

    if ((this.targetRequest.type == 2 || this.targetRequest.type == 3) && this.targetRequest.selectedOrgTypes && this.targetRequest.selectedItems) {
      let itemIds = this.targetRequest.selectedItems.map(x => x.id)
      let orgTypeIds = this.targetRequest.selectedOrgTypes.map(x => x.id)

      this.targetRequest.userTargetRequestDetail = this.targetRequest.userTargetRequestDetail.filter(x =>
        itemIds.indexOf(x.itemId) > -1 && orgTypeIds.indexOf(x.organizationTypeId) > -1
        && monthIds.indexOf(x.month) > -1 && x.year == this.selectedYear);

      this.targetRequest.selectedOrgTypes.forEach(org => {
        this.targetRequest.selectedItems.forEach(item => {
          this.selectedMonths.forEach(month => {
            let entry = this.targetRequest.userTargetRequestDetail.find(
              x => x.itemId === item.id && x.month === month.id && x.organizationTypeId == org.id
            );
            if (!entry) {
              this.targetRequest.userTargetRequestDetail.push({
                itemId: item.id, month: month.id, target: 0, year: this.selectedYear, organizationTypeId: org.id, itemBrandId: item.itemBrandId
              })
            }
          });
        })
      })
    }

    if (this.targetRequest.type == 4 && this.targetRequest.selectedHcos && this.targetRequest.selectedItems) {
      let itemIds = this.targetRequest.selectedItems.map(x => x.id)
      let hcoIds = this.targetRequest.selectedHcos.map(x => x.id)

      this.targetRequest.userTargetRequestDetail = this.targetRequest.userTargetRequestDetail.filter(x =>
        itemIds.indexOf(x.itemId) > -1 && hcoIds.indexOf(x.hcoId) > -1
        && monthIds.indexOf(x.month) > -1 && x.year == this.selectedYear);

      this.targetRequest.selectedHcos.forEach(hco => {
        this.targetRequest.selectedItems.forEach(item => {
          this.targetRequest.selectedMonths.forEach(month => {
            let entry = this.targetRequest.userTargetRequestDetail.find(
              x => x.itemId === item.id && x.month === month.id && x.hcoId == hco.id
            );
            if (!entry) {
              this.targetRequest.userTargetRequestDetail.push({
                itemId: item.id, month: month.id, target: 0, year: this.selectedYear, hcoId: hco.id, organizationTypeId: hco.organizationTypeId, itemBrandId: item.itemBrandId
              })
            }
          });
        })
      })
    }

    this.applyFilters = true;
    this.pageSize = this.targetRequest.userTargetRequestDetail.length + 1;
  }

  getValue(itemBrandId: number, monthId: number) {
    try {
      let entry = this.targetRequest.userTargetRequestDetail.find(
        x => x.itemBrandId === itemBrandId && x.month === monthId
      );

      return entry.target;
    }
    catch (error) { }
  }

  setValue(itemBrandId: number, monthId: number, val: any) {
    try {
      let entry = this.targetRequest.userTargetRequestDetail.find(
        x => x.itemBrandId === itemBrandId && x.month === monthId
      );

      entry.target = Number(val);
    }
    catch (error) { }
  }

  getOrgTypeItemValue(itemId: number, organizationTypeId: number, monthId: number) {
    try {
      let entry = this.targetRequest.userTargetRequestDetail.find(
        x => x.itemId === itemId && x.organizationTypeId === organizationTypeId && x.month === monthId
      );

      return entry.target;
    }
    catch (error) { }
  }

  setOrgTypeItemValue(itemId: number, organizationTypeId: number, monthId: number, val: any) {
    try {
      let entry = this.targetRequest.userTargetRequestDetail.find(
        x => x.itemId === itemId && x.organizationTypeId === organizationTypeId && x.month === monthId
      );

      entry.target = Number(val);
    }
    catch (error) { }
  }



  getHcoItemValue(itemId: number, hcoId: number, monthId: number) {
    try {
      let entry = this.targetRequest.userTargetRequestDetail.find(
        x => x.itemId === itemId && x.hcoId === hcoId && x.month === monthId
      );

      return entry.target;
    }
    catch (error) { }
  }

  setHcoItemValue(itemId: number, hcoId: number, monthId: number, val: any) {
    try {
      let entry = this.targetRequest.userTargetRequestDetail.find(
        x => x.itemId === itemId && x.hcoId === hcoId && x.month === monthId
      );

      entry.target = Number(val);
    }
    catch (error) { }
  }

  getMonthTotal(monthId) {
    let res = this.targetRequest.userTargetRequestDetail.filter(x => x.month === monthId);

    return !res || res.length == 0 ? 0 : res.reduce((sum, x) => sum + x.target, 0);
  }


}
